import { Search } from 'lucide-react'

import { CheckinLayout } from './CheckinLayout'
import { SelectionCard } from './SelectionCard'
import { StepHeader } from './StepHeader'

interface SideStepProps {
  onSelectSide: (side: 'groom' | 'bride') => void
  onSearchAll: () => void
}

export function SideStep({ onSelectSide, onSearchAll }: SideStepProps) {
  return (
    <CheckinLayout>
      <h2 className="mb-8 text-center font-serif text-3xl font-medium">
        ลงทะเบียนเข้างาน
      </h2>
      <StepHeader title="คุณมาในฝ่ายไหน?" />
      <div className="space-y-4">
        <SelectionCard
          label="ฝ่ายเจ้าบ่าว"
          sublabel="แขกของ OA"
          onClick={() => onSelectSide('groom')}
        />
        <SelectionCard
          label="ฝ่ายเจ้าสาว"
          sublabel="แขกของ KOI"
          onClick={() => onSelectSide('bride')}
        />
        <button
          type="button"
          onClick={onSearchAll}
          className="text-foreground/50 flex w-full items-center justify-center gap-2 py-3 text-sm transition-all hover:opacity-80 active:scale-[0.98]"
        >
          <Search className="size-4" />
          ไม่แน่ใจ? ค้นหาจากทั้งหมด
        </button>
      </div>
    </CheckinLayout>
  )
}
